document.addEventListener('Searchanise.Loaded', function () {
    (function ($) {
        function checkPage(snizeResultsPage) {
            let url = new URL(window.location.href);
            let currentPage = url.searchParams.get('page');
            if (snizeResultsPage == currentPage) {
                return true;
            } else if (snizeResultsPage == 1 && currentPage == null) {
                return true;
            } else {
              return false;
            }
        }
      
        function snizeAddCollectionBanner(snizeColUrl, snizeBannerUrl, snizeBannerPosition, snizeCurrentUrl, snizeResultsPage) {
            if ($(location).attr('href').includes(snizeCurrentUrl) && checkPage(snizeResultsPage)) {
                $(`ul.snize-search-results-content li:nth-child(${snizeBannerPosition})`).before(`
                <li class="snize-banner snize-custom-banner"><a href=${snizeColUrl} target="_blank"><img src=${snizeBannerUrl}></a></li>`
                );
            }
        }
        let snizeBannersData = [
            {
                //collection where banner is using  
                collection: 'https://marissacollections.com/collections/gifts-marissa-moms',
                //link for redirect after clicking
                link: 'https://marissacollections.com/collections/marissa-moms-jitka-stylist',
                //link to the banner image
                bannerImage: 'https://cdn.shopify.com/s/files/1/0333/8892/0967/files/Jitka_9aadba34-e0a3-43b5-8800-bbaf5482c1bb.jpg?v=1744200268',
                //banner position
                bannerPosition: 4, 
                //number of the search results page the banner should be displayed for
                resultsPage: 1
            },
            {
                collection: 'https://marissacollections.com/collections/gifts-marissa-moms',
                link: 'https://marissacollections.com/collections/marissa-moms-ashley-graphic-designer',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0333/8892/0967/files/Ash.jpg?v=1744200268',
                bannerPosition: 15,
                resultsPage: 1
            },
            {
                collection: 'https://marissacollections.com/collections/gifts-marissa-moms',
                link: 'https://marissacollections.com/collections/marissa-moms-beth-stylist-liv-store-assistant',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0333/8892/0967/files/Liv_Beth.jpg?v=1744200268',
                bannerPosition: 32,
                resultsPage: 1
            },
            {
                collection: 'https://marissacollections.com/collections/gifts-marissa-moms',
                link: 'https://marissacollections.com/collections/marissa-moms-melina-buyers-assistant',
                bannerImage: 'https://cdn.shopify.com/s/files/1/0333/8892/0967/files/Melina.jpg?v=1744200268',
                bannerPosition: 13,
                resultsPage: 2
            }
        ];
        $(document).on('Searchanise.ResultsUpdated', function () {
            if (!$('.snize-custom-banner').length) {
                snizeBannersData.forEach(function (bannerData) {
                    snizeAddCollectionBanner(bannerData.link, bannerData.bannerImage, bannerData.bannerPosition, bannerData.collection, bannerData.resultsPage);
                });
            }
        });
    })(window.Searchanise.$);
});